const XLogo = () => (
  <svg
    width="33"
    height="29"
    viewBox="0 0 33 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.65177 5.18311L14.2936 15.0546L6.60352 23.0805H8.33425L15.0669 16.0537L20.5067 23.0805H26.3965L18.3247 12.6538L25.4826 5.18311H23.7518L17.5514 11.6547L12.5415 5.18311H6.65177ZM9.19694 6.41475H11.9027L23.8509 21.8487H21.1451L9.19694 6.41475Z"
      fill="black"
    />
  </svg>
);
export default XLogo;
